<template>
    <div>
        <manage-password :title="$translate('user_profile')" />
    </div>
</template>

<script>
import ManagePassword from '../components/ManagePassword.vue'

export default {
    components: { ManagePassword },
    name: 'UserProfile',
}
</script>